import { ServiceTypeBase } from '../../models/serviceTypeBase';
import { Component, Input, OnInit } from '@angular/core';
import { ServiceTypeComponent } from '../../models/interfaces';
import { AccommodationServiceOrderExtension } from '@secca/shared/models/service-order/accommodation-service-order-extension';
import { CommitmentTypes, StatusTypes } from '@secca/shared/models/enums';
import { CaseStakeholder } from '@secca/shared/models/caseStakeholder';
import { SubStakeholder } from '../../models/subStakeholder';
import { DocumentTemplateFilter } from '../../sub-components/sub-gop-details/documentTemplateFilter';
import moment from 'moment-timezone';

@Component({
    selector: 'app-home-and-property',
    templateUrl: './home-and-property.component.html',
    standalone: false
})
export class HomeAndPropertyComponent extends ServiceTypeBase implements OnInit, ServiceTypeComponent {
  @Input() homeAndProperty: AccommodationServiceOrderExtension;
  @Input() leftSideValid = false;
  @Input() caseId: string;
  @Input() incidentId: string;
  @Input() supplier: SubStakeholder;
  @Input() stakeholders: CaseStakeholder[];
  @Input() gopPreviewModelChanged: boolean;

  homeAndPropertyTemplatesFilter = new DocumentTemplateFilter('DOCUMENT', ['GOP'], 'HOME_AND_PROPERTY');

  defaultStartDate = moment.utc().set({ hour: 9, minute: 0, second: 0, millisecond: 0 });
  defaultEndDate = moment.utc().set({ hour: 15, minute: 0, second: 0, millisecond: 0 });

  constructor() {
    super();
  }

  ngOnInit() {}

  isValid(): boolean {
    if (!this.homeAndProperty.commitmentType) {
      this.leftSideValid = false;
      return false;
    }
    if (!this.isDurationValid()) {
      this.leftSideValid = false;
      return false;
    }
    if (this.isGopCommitmentType && !this.homeAndProperty.gopDetails.isValid()) {
      this.leftSideValid = false;
      return false;
    }
    this.leftSideValid = true;
    return true;
  }

  private get isGopCommitmentType(): boolean {
    return !!this.homeAndProperty.commitmentType
      && this.homeAndProperty.commitmentType.businessKey === CommitmentTypes.REQUEST_ASSISTANCE;
  }

  private isDurationValid(): boolean {
    const durations = this.homeAndProperty.durations;
    if (!durations || durations.length === 0) {
      return false;
    }
    if (!durations[0].isGopPeriodsValid()) {
      return false;
    }
    for (let i = 1; i < durations.length; i++) {
      if (!durations[i].isGopPeriodsValid()) {
        return false;
      }
    }
    return true;
  }

  getModel(): AccommodationServiceOrderExtension {
    return this.homeAndProperty;
  }

  get CommitmentTypes() {
    return CommitmentTypes;
  }

  get StatusTypes() {
    return StatusTypes;
  }
}
